import api from './index';
//
let exports = {};

//获取发货单列表
exports.getGoodsShipVoucherList = function (postData, callback) {// 获取发货单列表
    api.post('/goodsDeliv/ship/voucher/list')
        .data(postData)
        .done(callback)
        .go();
};

//拒收
exports.refuseGoodsShipVoucher = function (postData, callback) {// 拒绝收货
    api.post('/goodsDeliv/ship/voucher/refuse/do')
        .data(postData)
        .done(callback)
        .go();
};

//获取发货单信息
exports.getGoodsShipVoucherInfo = function (postData, callback) {// 获取发货单详情
    api.post('/goodsDeliv/ship/voucher/info/get')
        .data(postData)
        .done(callback)
        .go();
};

//获取发货单商品项
exports.getGoodsShipVoucherItemList = function (postData, callback) {// 获取发货单商品项
    api.post('/goodsDeliv/ship/voucher/item/list/get')
        .data(postData)
        .done(callback)
        .go();
};

//查询（商品）收货单列表
exports.getGoodsRecvVoucherList = function (params, callback) {// （商品）退换/收货单列表
    api.post('/goodsDeliv/recv/voucher/list/get')
        .data(params)
        .done(callback)
        .go();
};

//查询（商品）收货单详情
exports.getGoodsRecvVoucherInfo = function (params, callback) {// （商品）退换/收货详情
    api.post('/goodsDeliv/recv/voucher/info/get')
        .data(params)
        .done(callback)
        .go();
};

//保存收货单
exports.saveGoodsRecvVoucher = function (params, callback) {// 保存收货单
    api.post('/goodsDeliv/recv/voucher/save/do')
        .data(params)
        .done(callback)
        .go();
};

//获取收货单相关商品
exports.getGoodsRecvVoucherItemList = function (params, callback) {// 获取收货单商品列表
    api.post('/goodsDeliv/recv/voucher/item/list/get')
        .data(params)
        .done(callback)
        .go();
};

// 获取收货单明细项
exports.getGoodsRecvDevcItemList = function (data, callback) {// 获取（商品）退换货设备列表
    api.post('/goodsDeliv/recv/devc/item/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 获取收货单明细项-可退、换货的
exports.getGoodsRecvDevcItemListForSelect = function (data, callback) {
    api.post('/goodsDeliv/recv/devc/item/select/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 获取收货单相关商品对应的资产列表
exports.getGoodsRecvVoucherItemRelAssetList = function (data, callback) {// 获取收货单相关商品对应的资产列表
    api.post('/goodsDeliv/recv/voucher/item/rel/asset/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 获取收货单商品已入库、已验收、已退货、已换货数量
exports.getGoodsRecvVoucherItemQuantityList = function (data, callback) {// 获取收货单商品已入库、已验收、已退货、已换货数量
    api.post('/goodsDeliv/recv/voucher/item/quantity/get')
        .data(data)
        .done(callback)
        .go();
};

//保存换货单
exports.saveGoodsExchgVoucher = function (params, callback) {// 保存换货单
    api.post('/goodsDeliv/exchg/voucher/save/do')
        .data(params)
        .done(callback)
        .go();
};

//保存退货单
exports.saveGoodsReturnVoucher = function (params, callback) {// 保存退货单
    api.post('/goodsDeliv/return/voucher/save/do')
        .data(params)
        .done(callback)
        .go();
};

//退换货发货
exports.updateGoodsRecvAndShipLogis = function (params, callback) {// 退换货发货
    api.post('/goodsDeliv/recv/and/ship/logis/update/do')
        .data(params)
        .done(callback)
        .go();
};
//退换货发货
exports.setSetLogisComInfo = function (params, callback) {// 退换货发货
    api.post('/goodsDeliv/recv/and/ship/logis/set/do')
        .data(params)
        .done(callback)
        .go();
};

// 获取实际收货数量
exports.getActualRecvQuantityByTrackPhaseId = function (postData, callback) {// 根据阶段id获取实际收货数量
    api.post('/goodsDeliv/actual/recv/quantity/get/by/trackPhaseId')
        .data(postData)
        .done(callback)
        .go();
};

// 查询商品标识码
exports.checkMerchtGoodsUknoByItems = function (params, callback) {// 查询商品标识码
    api.post('/goodsDeliv/mercht/goods/ukno/check/by/itemIds')
        .data(params)
        .done(callback)
        .go();
};

// 查询商品标识码
exports.getMerchtGoodsUknoListByFilter = function (params, callback) {// 查询商品标识码
    api.post('/goodsDeliv/mercht/goods/ukno/list/get/by/filter')
        .data(params)
        .done(callback)
        .go();
};
//
// ====================== 供商编码 ===========================

// 查询所有供商编码
exports.getMerchtGoodsUknoList = function (params, callback) {// 查询所有供商编码
    api.post('/goodsDeliv/mercht/goods/ukno/list/get')
        .data(params)
        .done(callback)
        .go();
};
// 新增编码
exports.saveMerchtGoodsUkno = function (params, callback) {// 新增编码
    api.post('/goodsDeliv/mercht/goods/ukno/save/do')
        .data(params)
        .done(callback)
        .go();
};
// 上传编码
exports.doMerchtGoodsUknoImport = function (params, callback) {// 新增编码
    api.post('/goodsDeliv/mercht/goods/ukno/import/do')
        .data(params)
        .done(callback)
        .go();
};

// 上传编码
exports.saveMerchtGoodsUknoParamsForExport = function (params, callback) {// 新增编码
    api.post('/goodsDeliv/ukno/params/for/export/url')
        .data(params)
        .done(callback)
        .go();
};
exports.saveMerchtGoodsUknoModelForExport = function (params, callback) {// 新增编码
    api.post('/goodsDeliv/ukno/model/for/export/url')
        .data(params)
        .done(callback)
        .go();
};
// 作废商品标识码
exports.doMerchtGoodsUKnoInvalid = function (params, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/invalid/do')
        .data(params)
        .done(callback)
        .go();
};
// 删除商品标识码
exports.doMerchtGoodsUKnoDelete = function (params, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/delete/do')
        .data(params)
        .done(callback)
        .go();
};
// 同步商品标识码中的内部编码
exports.updateMerchtGoodsUknoRetailerInnerNo = function (data, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/update/innerNo')
        .data(data)
        .done(callback)
        .go();
};
// 商品标识码-关联买家/解除买家
exports.updateMerchtGoodsUknoRetailerInfo = function (params, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/retailer/update/do')
        .data(params)
        .done(callback)
        .go();
};
// 查询商品标识码使用记录
exports.getMerchtGoodsUknoRecList = function (params, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/rec/list/get')
        .data(params)
        .done(callback)
        .go();
};

// ========================= 商品标识码回收单据 =======================

// 获取商品标识码回收单
exports.getMerchtGoodsUknoRevokeFormList = function (data, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/revoke/form/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 获取商品标识码回收单信息
exports.getMerchtGoodsUknoRevokeFormInfo = function (params, callback) {
    api.get('/goodsDeliv/mercht/goods/ukno/revoke/form/get')
        .params(params)
        .done(callback)
        .go();
};
// 保存商户商品唯一码回收单
exports.saveMerchtGoodsUknoRevokeForm = function (data, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/revoke/form/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 商户商品唯一码申请回收
exports.applyMerchtGoodsUknoRevokeForm = function (data, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/revoke/form/apply/do')
        .data(data)
        .done(callback)
        .go();
};
// 删除商户商品唯一码回收单
exports.doMerchtGoodsUknoRevokeFormDelete = function (data, callback) {
    api.post('/goodsDeliv/mercht/goods/ukno/revoke/form/delete/do')
        .data(data)
        .done(callback)
        .go();
};
exports.getGoodsRecvFileListByVoucherId = function (data, callback) {
    api.get('/goodsDeliv/recv/file/get/by/voucherId')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveGoodsRecvFile = function (data, callback) {
    api.post('/goodsDeliv/recv/file/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doCountFeeShare = function (data, callback) {
    api.post('/goodsDeliv/fee/share/count/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goodsDeliv.js
// module id = 39
// module chunks = 0